module.exports = __webpack_public_path__ + "static/widetile-e5cf5cc3e6f1a96501899f358be51dee.png";